// Getters
export const DATA_LOADED = 'dataLoaded'
export const PAYMENT_STATEMENTS = 'quarterlyStatements'
export const REPORT_LOADING = 'reportLoading'
export const REPORT_ERROR = 'reportError'
export const NO_DATA_ERROR = 'noDataError'
export const VIS_ERROR_OCCURED = 'visErrorOccured'

// Mutations
export const SET_DATA_LOADED = 'dataLoaded'
export const SET_PAYMENT_STATEMENTS = 'setPaymentStatements'
export const SET_REPORT_LOADING = 'setReportLoading'
export const SET_REPORT_ERROR = 'setReportError'
export const SET_NO_DATA_ERROR = 'setNoDataError'
export const SET_VIS_ERROR_OCCURED = 'setVisErrorOccured'

// Actions
export const UPDATE_PAYMENT_STATMENTS = 'updatePaymentStatements'
export const DOWNLOAD_EXCEL_REPORT = 'downloadExcelReport'
export const ACKNOWLEDGE_ERRORS = 'acknowledgeErrors'
